import './css/Settings.css'

const Settings = (props) => {
    return(
    <div className='setting-page'>
        <img src='https://cdn-icons-png.flaticon.com/128/900/900834.png'/>
        <span>Settings</span>
    </div>)
}

export default Settings;